import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiCalendar } = FiIcons;

const posts = [
  {
    date: 'December 20, 2021',
    title: 'What Are Web 2.0 Links And How To Build Them For Your Site?',
    excerpt: 'Want another way to drum up your link building efforts? Find out what web 2.0 links are and start building them to boost your cleaning business authority.',
    img: '/images/blog-1.webp',
    tag: 'Link Building',
  },
  {
    date: 'December 6, 2021',
    title: 'What Is Guest Posting In SEO: A Quick Guide',
    excerpt: '60% of blogs produce up to five guest posts every month. Learn how guest posting can drive traffic to your cleaning business website and build authority.',
    img: '/images/blog-2.webp',
    tag: 'SEO',
  },
  {
    date: 'November 15, 2021',
    title: 'When To Use FAQ Schema Markup: Best Practices',
    excerpt: "Answer your potential clients' questions with FAQ schema to boost confidence and increase your cleaning service website's visibility in Google search results.",
    img: '/images/blog-3.webp',
    tag: 'Technical SEO',
  },
];

const BlogSection = () => {
  return (
    <section id="blog" className="py-24 md:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="text-[#8cc63f] font-semibold text-sm uppercase tracking-widest block mb-2"
            >
              Recent Cleaning News & Tips
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-3xl md:text-4xl font-bold text-[#4b4b4b] tracking-tight"
            >
              Marketing Tips for Cleaning Businesses
            </motion.h2>
          </div>
          <a href="#" className="text-[#8cc63f] hover:text-[#7ab535] font-semibold flex items-center gap-2 transition-colors whitespace-nowrap">
            More Cleaning Tips <FiArrowRight />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {posts.map((post, idx) => (
            <motion.article
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#8cc63f]/40 hover:shadow-xl hover:shadow-[#8cc63f]/10 transition-all duration-300 group cursor-pointer"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={post.img}
                  alt={post.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="inline-block text-xs font-bold text-[#8cc63f] bg-[#8cc63f]/10 px-3 py-1 rounded-full mb-3">
                  {post.tag}
                </span>
                <div className="flex items-center gap-2 text-gray-400 text-xs mb-3">
                  <FiCalendar className="text-xs" />
                  By Get Cleaning Clicks | {post.date}
                </div>
                <h3 className="font-bold text-[#4b4b4b] text-base leading-snug mb-3 group-hover:text-[#8cc63f] transition-colors">
                  {post.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed">{post.excerpt}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;